import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;
  @Input() emphasis: string;
  @Input() tooltipPosition = 'bottom';

  constructor() {}

  ngOnInit() {}
}
